import { render, staticRenderFns } from "./SortingByColumn.vue?vue&type=template&id=31824ed3&"
import script from "./SortingByColumn.vue?vue&type=script&lang=js&"
export * from "./SortingByColumn.vue?vue&type=script&lang=js&"
import style0 from "./SortingByColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports